import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  makeStyles
} from "@material-ui/core";
import { useState } from "react";
import { customtheme } from "../../../app/theme/theme";
import NumberInputWithSpinner from "./NumberInputWithSpinner";

const useStyles = makeStyles((theme) => ({
  drawer: { width: 400 },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
  },
  /* nova faixa para as tabs */
  tabsBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabRoot: {
    minWidth: 0,
    paddingLeft: 8,
    paddingRight: 8,
  },
  drawerContent: {
    overflowY: 'auto',
    padding: theme.spacing(2),
    height: '100%',
  },
  drawerFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
  },
  textField: {
    minWidth: 140,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& .MuiInputBase-input': { color: customtheme.black },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: customtheme.blue[500],
    },
  },
  searchIcon: {
    marginRight: theme.spacing(1),
    color: customtheme.blue[500],
  },
  backgroundColor: {
    background: customtheme.blue[500],
    color: customtheme.white,
    '&:hover': { background: customtheme.blue[50], color: customtheme.blue[500] },
  },
  backBackgroundColor: {
    background: customtheme.gray[200],
    color: customtheme.blue[500],
    '&:hover': { background: customtheme.blue[50], color: customtheme.blue[500] },
  },
}))

interface PurchaseOrderEmitParcelaDialogProps {
  handleClose: () => void;
  isDialogOpen: boolean;
  fieldsInit: any[];
  handleUpdateValue: (itens: any[]) => any;
}

const PurchaseOrderEmitParcelaDialog = (props: PurchaseOrderEmitParcelaDialogProps) => {
  const classes = useStyles()
  const {
    isDialogOpen, fieldsInit,
    handleClose, handleUpdateValue,
  } = props;

  const [fields, setFields] = useState<any[]>(fieldsInit);

  const handleAddItem = () => {
    handleUpdateValue(fields);
  }

  const handleValueSpinnerChange = (value: number | null) => {
    const upd = [...fields];
    upd[upd.findIndex(f => f.id === 'vlrpar')].value = {
      vlrpar: value ? value : 0.00,
    };
    setFields(upd);
  };

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Adicionar parcela</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>

              <Box display="flex" style={{ gap: 32 }}>
                <NumberInputWithSpinner
                  label="Valor parcela"
                  value={fields.find(f => f.id === 'vlrpar')?.value?.vlrpar || 0.01}
                  onChange={handleValueSpinnerChange}
                  step={0.01}
                  min={0.01}
                />

                {/* --- Datas --- */}
                <TextField
                  label="Data Parcela"
                  type="date"
                  value={fields.find(f => f.id === 'vctpar')?.value?.vctpar || new Date().toISOString().split('T')[0]}
                  onChange={e => {
                    const upd = [...fields];
                    upd[upd.findIndex(f => f.id === 'vctpar')].value = { vctpar: e.target.value };
                    setFields(upd);
                  }}
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <>
            <Button
              onClick={handleClose}
              className={classes.backBackgroundColor}
              style={{
                marginRight: 20,
              }}
            >
              Voltar
            </Button>
            <Button
              onClick={handleAddItem}
              className={classes.backgroundColor}
            >
              Confirmar
            </Button>
          </>
        </DialogActions>
      </Dialog> 
    </>
  )
}

export default PurchaseOrderEmitParcelaDialog;